import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Config from "../../../../Config";
import { color_white } from "../../../../constants/colors";
import { getWeeklyTasksList } from "../../../../pages/personal/PersonalPage";
import {
  removeTask,
  replaceAllTasks,
  updateTask,
} from "../../../../store/tasksListSlice";
import { useWindowDimensions } from "../../../../utils";
import { LoadingContainer } from "../../../containers/LoadingContainer";
import NoContentPlaceholder from "../../../containers/NoContentPlaceholder";
import EditIcon from "../../../icons/EditIcon";
import { OnestSemiBoldMed } from "../../../styled/TextComponents";
import { WeeklyTasksUpdateModal } from "../weeklyTasksUpdateModal/WeeklyTasksUpdateModal";
import { styles } from "./Styles";
import { WeeklyTaskRow } from "./WeeklyTaskRow";
import { useI18n } from "../../../../i18n/I18nProvider";

export class WeeklyTask {
  constructor(id, title, completed) {
    this.id = id;
    this.title = title;
    this.initialTitle = title;
    this.completed = completed;
  }
}

/**
 * Weekly tasks list component.
 * @returns {JSX.Element}
 * @constructor}
 */

export const WeeklyTasksList = () => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const [isLoading, setIsLoading] = useState(true);
  const tasksList = useSelector((state) => state.tasksList);
  const [tasksUpdatingState, setTasksUpdatingState] = useState(false);
  const dispatch = useDispatch();

  const completedCount = tasksList.filter((task) => task.completed).length;

  const taskToggleCallback = (task) => {
    dispatch(updateTask({ ...task, completed: !task.completed }));
    handleTaskUpdate({
      task_id: task.id,
      task_text: task.title,
      completed: !task.completed,
    });
  };

  async function getTasksFromServer() {
    getWeeklyTasksList().then((res) => {
      dispatch(replaceAllTasks(res));
      setIsLoading(false);
    });
  }

  async function handleTaskRemove(taskId) {
    let response = await axios.delete(Config.BACKEND_ADDR + `/tasks/${taskId}`);
    await dispatch(removeTask(tasksList.find((el) => el.id === taskId)));
  }

  async function handleTaskUpdate(updatedData) {
    let response = await axios.patch(
      Config.BACKEND_ADDR + `/tasks/`,
      updatedData,
    );
    await dispatch(
      updateTask({
        id: response.data.id,
        title: response.data.task_text,
        completed: response.data.completed,
      }),
    );
  }

  //Update tasks on mount
  useEffect(() => {
    getTasksFromServer().then();
  }, []);

  return (
    <div
      style={{
        borderRadius: 20,
        padding: 20,
        backgroundColor: color_white,
        height: screenWidth > 1180 ? screenHeight - 445 : 308,
        width:
          screenWidth > 1180
            ? screenWidth > 1400
              ? 335
              : 350
            : screenWidth > 740
              ? 320
              : "100%",
      }}
    >
      {/*Weekly tasks container*/}
      <div style={{ ...styles.weeklyTasksContainer }}>
        {/*Tasks updating modal*/}
        <WeeklyTasksUpdateModal
          isShown={tasksUpdatingState}
          onRequestClose={() => setTasksUpdatingState(false)}
        />

        {/*Tasks header with modal opening button*/}
        <div style={{ ...styles.weeklyTasksHeader }}>
          <div style={styles.weeklyTasksTitleGroup}>
            <OnestSemiBoldMed style={{ paddingTop: 10, paddingBottom: 10, minWidth: 0 }}>
              {t("Задачи на неделю")}
            </OnestSemiBoldMed>
            {tasksList.length > 0 ? (
              <span style={styles.weeklyTasksProgress}>
                {t("{{done}} из {{total}}", {
                  done: completedCount,
                  total: tasksList.length,
                })}
              </span>
            ) : null}
          </div>
          <div
            style={styles.weeklyTasksEditButton}
            onClick={() => setTasksUpdatingState(true)}
            role="button"
            aria-label={t("Редактировать задачи")}
          >
            <EditIcon />
          </div>
        </div>

        {/*Tasks list container*/}
        <div style={{ ...styles.weeklyTasksRowContainer }}>
          {/*Show loading while tasks downloading*/}
          <LoadingContainer isLoading={isLoading}>
            {/*Tasks list generator*/}
            {tasksList.length === 0 ? (
              // If there are  no tasks then show placeholder

              <NoContentPlaceholder
                noDataText={t("Здесь будут отображаться ваши задачи на неделю")}
              />
            ) : (
              // If we have at least one task, then generate task row for each task
              tasksList.map((el, index) => {
                return (
                  <WeeklyTaskRow
                    key={index}
                    task={el}
                    isLastTask={index === tasksList.length - 1}
                    toggleTaskCallBack={taskToggleCallback}
                  />
                );
              })
            )}
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
};
